/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Createfirstdescription3Inputs */

const zh_organizationsettings_createfirstdescription3 = /** @type {(inputs: Organizationsettings_Createfirstdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织和团队分享都依赖这里创建的工作区。`)
};

const en_organizationsettings_createfirstdescription3 = /** @type {(inputs: Organizationsettings_Createfirstdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization and team sharing depend on the workspace you create here.`)
};

const es_organizationsettings_createfirstdescription3 = /** @type {(inputs: Organizationsettings_Createfirstdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El uso compartido por organización y equipo depende del espacio de trabajo que crees aquí.`)
};

/**
* | output |
* | --- |
* | "Organization and team sharing depend on the workspace you create here." |
*
* @param {Organizationsettings_Createfirstdescription3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_createfirstdescription3 = /** @type {((inputs?: Organizationsettings_Createfirstdescription3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Createfirstdescription3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_createfirstdescription3(inputs)
	if (locale === "en") return en_organizationsettings_createfirstdescription3(inputs)
	return es_organizationsettings_createfirstdescription3(inputs)
});
export { organizationsettings_createfirstdescription3 as "organizationSettings_createFirstDescription" }